export default "__VITE_ASSET__16c27e7d__"